import { render, staticRenderFns } from "./SerialBoost.vue?vue&type=template&id=cfc8e7c0&scoped=true"
import script from "./SerialBoost.vue?vue&type=script&lang=js"
export * from "./SerialBoost.vue?vue&type=script&lang=js"
import style0 from "./SerialBoost.vue?vue&type=style&index=0&id=cfc8e7c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc8e7c0",
  null
  
)

export default component.exports